module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_1.825b60ad.png";